import { useState, useRef } from 'react';
import { StatusCodes } from 'http-status-codes';
import { Link, useHistory } from 'react-router-dom';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import GridWrapper from '~/src/components/common/GridWrapper';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { withState } from '~/src/components/common/grid/WrappedGrid';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import { API_URL, CONSOLIDATION_STATUS } from '~/src/utils/constants';
import { CreatedOnCell } from '~/src/components/common/grid/Cells';
import ExternalUsersApi from '~/src/services/api/ExternalUsersApi';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';
import TertiaryButton from '~/src/components/common/forms/Button/TertiaryButton';
import LinkButton from '~/src/components/common/forms/Button/LinkButton';

export default function ExternalOrders(): JSX.Element {
  const stateRef = useRef(null);
  const history = useHistory();
  const [consolidationStatus, setConsolidationStatus] = useState(null);
  const url = `${API_URL}/orders/get-external-orders`;
  const StatefullGrid = withState(Grid, url);

  const changeStatus = async (data, id: string) => {
    const status = { status: data };
    const res = await ExternalUsersApi.changeStatus(status, id);

    if (res.status === StatusCodes.OK) {
      setConsolidationStatus(res.data.consolidationStatus);
    }
  };

  const ActionCell = (row, ref) => {
    const { dataItem } = row;
    const consolidationStatus = dataItem?.consolidationStatus;

    return (
      <td>
        {consolidationStatus == CONSOLIDATION_STATUS.ConfirmedByOwner && (
          <SecondaryButton
            title="Start"
            onClick={() => changeStatus(CONSOLIDATION_STATUS.InConsolidation, dataItem?.id)}
          />
        )}
        {consolidationStatus == CONSOLIDATION_STATUS.InConsolidation && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TertiaryButton
              title="Finish"
              onClick={() => changeStatus(CONSOLIDATION_STATUS.Consolidated, dataItem?.id)}
            />
            <div style={{ margin: 5 }}></div>
            <LinkButton
              title="Cancel"
              onClick={() => changeStatus(CONSOLIDATION_STATUS.ConfirmedByOwner, dataItem?.id)}
            />
          </div>
        )}
        {consolidationStatus == CONSOLIDATION_STATUS.Consolidated && (
          <BorderlessButton
            title="Edit"
            onClick={() => changeStatus(CONSOLIDATION_STATUS.InConsolidation, dataItem?.id)}
          />
        )}
      </td>
    );
  };

  const orderCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/orders/status/${dataItem.id}`}>{dataItem?.orderNumber}</Link>
      </td>
    );
  };

  const warehouseOwnerCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/orders/status/${dataItem.id}`}>{dataItem?.warehouseOwner.name}</Link>
      </td>
    );
  };

  const statusCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/orders/status/${dataItem.id}`}>{dataItem?.consolidationStatus}</Link>
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="Orders to be consolidated"
        onLeftHandler={(): void => {
          history.push('/');
        }}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="orderNumber" title="Order" cell={orderCell} />
          <GridColumn
            field="warehouseOwner.name"
            title="Warehouse Owner"
            cell={(row) => warehouseOwnerCell(row, stateRef)}
          />
          <GridColumn field="createdOn" title="Date" cell={CreatedOnCell} filter='date' />
          <GridColumn field="consolidationStatus" title="Status" cell={(row) => statusCell(row, stateRef)} />
          <GridColumn field="actions" title="Actions" cell={(row) => ActionCell(row, stateRef)} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
